export const translations = {
  en: {
    seo: {
      title: "METANOIA | Beyond Ordinary - Exclusive Beer",
      description: "Request access to METANOIA. An ultra-exclusive, premium beer crafted for the extraordinary."
    },
    tagline: "EXCLUSIVE BEER",
    headline: "Beyond",
    headlineItalic: "Ordinary",
    cta: "Apply for Allocation",
    close: "Close",
    joinWaitlist: "Join the Waitlist",
    loadingForm: "Loading secure form...",
    backHome: "Back to Home",
    imprintLink: "Imprint",
    privacyLink: "Privacy Policy",
    rights: "All rights reserved.",
    allocationIntro: "100 Bottles. Hand-Brewed in Barberà del Vallès. Allocation Only.",
    allocationSub: "Batch #1 allocation is open.",
    realityTitle: "The Reality:",
    realityText: "We brew in a small, private facility in Barberà del Vallès. Zero automation. Zero compromises. We make exactly 100 bottles. Not one more. When they are gone, you missed it.",
    offerTitle: "The Offer:",
    offerText: "This beer does not exist yet. You are not buying dusty inventory off a shelf. You are securing a numbered first edition. You are an investor in a hand-crafted masterpiece. Once we hit 100 reservations, this page shuts down. Then, the brewing begins.",
    liveStatus: "Live Status: Only 64 of 100 allocations remain.",
    legal: {
      title: "Imprint (Legal Notice)",
      responsible: "Responsible for Content: Mathias Deppe",
      address: "Address: Nemesi Valls 42, 08210 Barberà del Vallès, Barcelona, Spain",
      contact: "Contact & Support: Email: contact@metanoia.beer | Phone: +34 623780182",
      tax: "Tax Identification: VAT/Tax ID (NIF/NIE): Y8187448Z",
      dispute: "EU Dispute Resolution: The European Commission provides a platform for online dispute resolution (ODR): https://ec.europa.eu/consumers/odr. We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board."
    },
    privacy: {
      title: "Privacy Policy",
      effectiveDate: "Effective Date: 27.07.2026",
      intro: "We respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website, download our free resources, or subscribe to our newsletter.",
      sections: [
        {
          title: "1. Information We Collect",
          content: "We believe in data minimization and only collect the information absolutely necessary to provide you with the content you request. For PDF Freebie Downloads & Newsletter Subscribers: When you sign up to receive our free PDF or opt-in to our newsletter, we collect your email address."
        },
        {
          title: "2. How We Use Your Data",
          content: "We use the information we collect strictly for the following purposes: To deliver the requested PDF freebie to your inbox. To send you marketing newsletters and fitness updates (only if you have explicitly opted in)."
        },
        {
          title: "3. Cookies",
          content: "We respect your privacy and do not use invasive tracking, advertising, or third-party analytics cookies on your device. Any cookies used by our website hosting platform are strictly essential for the basic technical functioning and security of the site."
        },
        {
          title: "4. Third-Party Service Providers",
          content: "We do not sell, rent, or share your personal data with marketing firms or data brokers. We only share necessary data with trusted third-party platforms that help us run our site: SendFox (Newsletter and Email Delivery): We use SendFox (Sumo Group Inc.) to manage our communications. Your data is stored on their secure servers in the USA. Google Drive: Used for file hosting; they may collect standard traffic data when you access files."
        },
        {
          title: "5. Your Rights and Choices",
          content: "You have full control over your personal data. You have the right to access, correct, or delete your personal information. You can opt-out at any time via the 'unsubscribe' link or by contacting us directly."
        }
      ],
      contact: "Contact Us: If you have any questions about this Privacy Policy, please reach out to us at contact@metanoia.beer"
    }
  },
  es: {
    seo: {
      title: "METANOIA | Más allá de lo ordinario - Cerveza Exclusiva",
      description: "Solicita acceso a METANOIA. Una cerveza premium ultra exclusiva, elaborada para lo extraordinario."
    },
    tagline: "CERVEZA EXCLUSIVA",
    headline: "Más allá de lo",
    headlineItalic: "Ordinario",
    cta: "Solicitar Asignación",
    close: "Cerrar",
    joinWaitlist: "Únete a la lista",
    loadingForm: "Cargando formulario...",
    backHome: "Volver al Inicio",
    imprintLink: "Aviso Legal",
    privacyLink: "Política de Privacidad",
    rights: "Todos los derechos reservados.",
    allocationIntro: "100 Botellas. Elaborado a mano en Barberà del Vallès. Solo por Asignación.",
    allocationSub: "La asignación para el Lote #1 está abierta.",
    realityTitle: "La Realidad:",
    realityText: "Elaboramos en una pequeña instalación privada en Barberà del Vallès. Cero automatización. Cero compromisos. Hacemos exactamente 100 botellas. Ni una más. Cuando se acaban, te lo perdiste.",
    offerTitle: "La Oferta:",
    offerText: "Esta cerveza aún no existe. No estás comprando inventario de un estante. Estás asegurando una primera edición numerada. Eres un inversor en una obra maestra artesanal. Una vez que alcancemos 100 reservas, esta página se cierra. Entonces, empezamos a elaborar.",
    liveStatus: "Estado en Vivo: Solo quedan 64 de 100 asignaciones.",
    legal: {
      title: "Aviso Legal",
      responsible: "Responsable del contenido: Mathias Deppe",
      address: "Dirección: Nemesi Valls 42, 08210 Barberà del Vallès, Barcelona, España",
      contact: "Contacto y Soporte: Correo electrónico: contact@metanoia.beer | Teléfono: +34 623780182",
      tax: "Identificación Fiscal: NIF/NIE: Y8187448Z",
      dispute: "Resolución de Litigios de la UE: La Comisión Europea ofrece una plataforma para la resolución de litigios en línea (RLL): https://ec.europa.eu/consumers/odr. No estamos dispuestos ni obligados a participar en procedimientos de resolución de conflictos ante una junta de arbitraje de consumo."
    },
    privacy: {
      title: "Política de Privacidad",
      effectiveDate: "Fecha de vigencia: 27.07.2026",
      intro: "Respetamos su privacidad y estamos comprometidos a proteger sus datos personales. Esta Política de Privacidad explica cómo recopilamos, utilizamos y protegemos su información cuando visita nuestro sitio web, descarga nuestros recursos gratuitos o se suscribe a nuestro boletín (newsletter).",
      sections: [
        {
          title: "1. Información que recopilamos",
          content: "Creemos en la minimización de datos y solo recopilamos la información absolutamente necesaria. Para descargas de PDF y suscriptores: Recopilamos su dirección de correo electrónico cuando se registra para recibir contenido o nuestro boletín."
        },
        {
          title: "2. Cómo utilizamos sus datos",
          content: "Utilizamos su información estrictamente para: Enviar el PDF gratuito solicitado a su bandeja de entrada y enviarle boletines de marketing (solo si ha dado su consentimiento explícito)."
        },
        {
          title: "3. Cookies",
          content: "No utilizamos cookies invasivas de rastreo o publicidad. Solo utilizamos cookies técnicas estrictamente esenciales para el funcionamiento y seguridad del sitio."
        },
        {
          title: "4. Proveedores de servicios de terceros",
          content: "No vendemos sus datos. Utilizamos SendFox (Sumo Group Inc.) para envíos de correo, cuyos servidores están en EE. UU., y Google Drive para el alojamiento de archivos PDF."
        },
        {
          title: "5. Sus derechos y opciones",
          content: "Usted tiene control total. Tiene derecho a acceder, corregir o eliminar su información. Puede darse de baja en cualquier momento mediante el enlace de 'cancelar suscripción' o contactándonos."
        }
      ],
      contact: "Contáctenos: Si tiene alguna pregunta sobre esta Política de Privacidad, comuníquese con nosotros en contact@metanoia.beer"
    }
  }
};